export const addAdvancedErrorManagementInterceptors = (instance) => {
    instance.interceptors.request.use((config) => {
        config.errorContext = new Error("Thrown at:");
        return config;
    });
    instance.interceptors.response.use(undefined, async (error) => {
        const originalStackTrace = error.config?.errorContext?.stack;
        if (originalStackTrace) {
            error.stack = `${error.stack}\n${originalStackTrace}`;
        }
        throw error;
    });
};
//# sourceMappingURL=errorManagement.js.map